import { Component, Input, OnInit } from '@angular/core';
import { FileTextOutline } from '@ant-design/icons-angular/icons';
import { IconService } from '@ant-design/icons-angular';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent implements OnInit {
  @Input()
  lang?: string;

  termUrl = '';

  constructor(private readonly iconService: IconService) {}

  ngOnInit(): void {
    this.termUrl = `${this.lang}/terms`;
    this.iconService.addIcon(FileTextOutline);
  }
}
